/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SafetyPredictionType {
  BELOW_LOWER_LIMIT = 'BELOW_LOWER_LIMIT',
  ABOVE_LOWER_LIMIT = 'ABOVE_LOWER_LIMIT',
  ABOVE_UPPER_LIMIT = 'ABOVE_UPPER_LIMIT',
}
